import { forwardRef, type HTMLAttributes } from 'react';
import { Badge } from '@accure/ui';

import { ErrorClass } from '@/platform-status/entities/platform-component';
import { errorClassBackgroundColor } from '@/platform-status/utils/error-class';
import { cls } from '@/utils/cls';

export type PlatformComponentStatusBadgeProps =
  HTMLAttributes<HTMLDivElement> & {
    activeErrorClass?: ErrorClass;
  };

export const PlatformComponentStatusBadge = forwardRef<
  HTMLDivElement,
  PlatformComponentStatusBadgeProps
>(({ activeErrorClass, className, ...props }, ref) => {
  switch (activeErrorClass) {
    case undefined: {
      return (
        <Badge
          {...props}
          ref={ref}
          variant="default"
          className={cls('bg-primary-500 text-sm', className)}
        >
          Operational
        </Badge>
      );
    }
    case ErrorClass.ERROR_CLASS_2: {
      return (
        <Badge
          {...props}
          ref={ref}
          variant="outline"
          className={cls(
            'text-sm',
            errorClassBackgroundColor[activeErrorClass],
            className,
          )}
        >
          Degraded Performance
        </Badge>
      );
    }
    case ErrorClass.ERROR_CLASS_1: {
      return (
        <Badge
          {...props}
          ref={ref}
          variant="destructive"
          className={cls(
            'text-sm',
            errorClassBackgroundColor[activeErrorClass],
            className,
          )}
        >
          Unavailable
        </Badge>
      );
    }
  }
});

PlatformComponentStatusBadge.displayName = 'PlatformComponentStatusBadge';
